/*
  Centers the map OverlayView
 */
export const getPixelPositionOffset = (width: number, height: number): { x: number; y: number } => ({
  x: -(width / 2),
  y: -(height / 2),
});
